import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

// Animation for text moving left to right

const moveRightToLeft = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const moveLeftToRight = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const Ticker = ({
  messages = "sample",
  direction = "left",
  speed = 5,
  position = "top",
  tickerTextColor,
  tickerBgColor,
  checkIfTrue,
}) => {
  const [directionTicker, setDirectionTicker] = useState(
    direction === "center" ? "LTR" : "",
  ); // Start Left to Right

  // Tickers alternative

  useEffect(() => {
    const interval = setInterval(() => {
      setDirectionTicker((prev) => (prev === "LTR" ? "RTL" : "LTR"));
    }, speed * 1000);

    return () => clearInterval(interval);
  }, [speed]);

  return position === "top" ? (
    <TopTickerContainer
      style={{
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </TopTickerContainer>
  ) : position === "bottom" ? (
    <BottomTickerContainer
      {...{ checkIfTrue }}
      style={{
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </BottomTickerContainer>
  ) : (
    <CenterTickerContainer
      style={{
        backgroundColor: tickerBgColor,
      }}
    >
      {direction === "center" ? (
        <AlternateTickerText
          direction={directionTicker}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </AlternateTickerText>
      ) : (
        <TickerText
          direction={direction}
          speed={speed}
          style={{
            color: tickerTextColor,
          }}
        >
          {messages}
        </TickerText>
      )}
    </CenterTickerContainer>
  );
};

export default Ticker;

const BottomTickerContainer = styled.div`
  position: fixed;
  bottom: 10px;
  left: 0;
  bottom: ${({ checkIfTrue }) => (checkIfTrue ? "6%" : "6.3%")};
  width: 100%;
  background: #ff5733;
  color: white;
  opacity: 0.8;
  padding: 10px 0;
  z-index: 9999;
  overflow: hidden;
  pointer-events: none;

  @media only screen and (max-width: 767px) {
    bottom: ${({ checkIfTrue }) => (checkIfTrue ? "6%" : "11.5%")};
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    bottom: ${({ checkIfTrue }) => (checkIfTrue ? "6%" : "8.5%")};
  }
`;

const TopTickerContainer = styled.div`
  position: fixed;
  top: 9%;
  left: 0;
  width: 100%;
  background: #ff5733;
  padding: 8px 0;
  opacity: 0.8;
  text-align: center;
  overflow: hidden;
  pointer-events: none;
  z-index: 9999;
`;

const CenterTickerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  background: #ff5733;
  color: white;
  opacity: 0.8;
  padding: 10px 0;
  z-index: 9999;
  overflow: hidden;
  pointer-events: none;
`;

const TickerText = styled.div`
  display: inline-block;
  white-space: nowrap;
  font-size: 22px;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  width: 100%;
  animation: ${(props) =>
      props.direction === "left" ? moveLeftToRight : moveRightToLeft}
    ${(props) => props.speed}s linear infinite;
`;

const AlternateTickerText = styled.div`
  display: inline-block;
  white-space: nowrap;
  font-size: 22px;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  width: 100%;
  animation: ${(props) =>
      props.direction === "LTR" ? moveLeftToRight : moveRightToLeft}
    ${(props) => props.speed}s linear infinite;
`;